import Component from '../colorz/Component';
import Splide from '@splidejs/splide';
import {sliderOptions} from '../colorz/configClrzApp';

export default class LastReviewsYotpo extends Component {
	onInit(el) {
		this.el = el;
		this.slider = this.el;
		this.sliderList = this.slider.querySelector('.splide__list');
		this.numberReviews = Number(this.el.dataset.numberReviews) || 9;
		this.elTextBy = this.dataset?.StringReviewsBy || 'Reviews by';
		this.filterRated = this.el.dataset.filterRated;
		this.hideTaggedArray = (this.el.dataset.hideTagged || '')
			.split(',')
			.filter((tag) => tag.trim());
		this.appKey = this.el.dataset.yotpoAppKey;
		this.instanceId = this.el.dataset.yotpoInstanceId;
		this.locale = this.el.dataset.locale;
	}

	async onReady() {
		if (!this.appKey) {
			console.warn('Yotpo App Key missing');
			return;
		}

		this.data = await this.fetchProductReviews();

		if (this.data?.reviews?.length) {
			await this.renderReviews();
		}
	}

	async renderReviews() {
		const reviews = this.data.reviews.slice(0, this.numberReviews);
		const promises = reviews.map((review) => this.createElement(review));

		try {
			await Promise.all(promises);
			if (this.sliderList.children.length > 0) {
				this.initSlider();
				this.el.removeAttribute('hidden');
			}
		} catch (e) {
			console.error('Error rendering reviews', e);
		}
	}

	async createElement(el) {
		return new Promise(async (resolve) => {
			try {
				if (!el.content) return resolve();

				let productInfo = null;
				let reviewProductURL = '#';
				let reviewProductURLClass = 'u-pointer-events-none';

				// Match review product_id with products array to get domain_key
				let domainKey;
				if (el.product_id && this.data.products) {
					const product = this.data.products.find(
						(p) => p.id === el.product_id,
					);
					domainKey = product?.domain_key;
				}

				// Fetch Shopify product info using domain_key if available
				if (domainKey) {
					productInfo = await this.getProductInfo(domainKey);

					// Hide if product has tags that match hideTaggedArray
					const productTags = productInfo?.tags || [];
					if (
						this.hideTaggedArray.some((tag) => productTags.includes(tag.trim()))
					) {
						return resolve();
					}

					// Build product URL using Shopify handle if available
					if (productInfo) {
						reviewProductURL = `/products/${productInfo.handle}`;
						reviewProductURLClass = '';
					}
				}

				// Apply rating filter if configured
				if (this.filterRated) {
					const rating = el.score || 0;
					if (this.filterRated === '5' && rating !== 5) return resolve();
					if (this.filterRated === '4,5' && rating < 4) return resolve();
				}

				const reviewStars = this.drawRatingStars(el.score || 0).outerHTML;

				const productTitle =
					el.product_title || productInfo?.title || 'Product';

				const slideElement = document.createElement('div');
				slideElement.classList.add('splide__slide');

				const reviewElement = document.createElement('div');
				reviewElement.classList.add(
					'u-bg-white',
					'md:u-bg-blue-light',
					'u-py-20',
					'u-px-25',
					'md:u-p-0',
				);

				reviewElement.innerHTML = `
          <a href="${reviewProductURL}" class="u-relative u-flex u-flex-col t-text t-text--14 u-text-blue ${reviewProductURLClass}">
              <p class="u-relative">
                  <p class="u-underline u-underline-offset-4 u-decoration-2">
                      ${productTitle}
                  </p>
              </p>
              <div class="u-flex u-items-center u-gap-x-10 u-mt-10">
                  ${reviewStars} (${el.score || 0})
              </div>
              <p class="u-mt-10 u-break-words u-line-clamp-6 md:u-line-clamp-4">
                  ${el.content || ''}
              </p>
          </a>
        `;

				slideElement.appendChild(reviewElement);
				this.sliderList.appendChild(slideElement);

				resolve();
			} catch (error) {
				console.error('Error creating review element:', error);
				resolve();
			}
		});
	}

	drawRatingStars(rating) {
		const pourcentage = 100 - (rating / 5) * 100;
		const elStarts = document.createElement('div');
		elStarts.classList.add('u-grid', 'u-w-fit');

		elStarts.innerHTML = `
     <div class='u-flex u-gap-x-[8px] u-col-start-1 u-row-start-1'>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
				</svg>
			</div>
			<div
				class='u-flex u-gap-x-[8px] u-col-start-1 u-row-start-1 '
				style='clip-path: inset(0 ${pourcentage}% 0 0)'
			>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
				<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
				</svg>
			</div>
		`;

		return elStarts;
	}

	async fetchProductReviews() {
		try {
			if (!this.appKey) {
				console.warn('Missing Yotpo appKey');
				return {reviews: []};
			}

			const params = new URLSearchParams({
				count: this.numberReviews,
				page: 1,
				sort: 'date',
				direction: 'desc',
			});

			const response = await fetch(
				`https://api-cdn.yotpo.com/v1/widget/${
					this.appKey
				}/reviews.json?${params.toString()}`,
			);

			if (!response.ok) {
				throw new Error(`Yotpo CDN error: ${response.status}`);
			}

			const data = await response.json();

			return {
				reviews: data.response.reviews.map((review) => ({
					content: review.content,
					score: review.score,
					product_title: review.product?.title,
					product_id: review.product_id,
					created_at: review.created_at,
					reviewer_name: review.user?.display_name || 'Anonymous',
				})),
				products: data.response.products || [],
			};
		} catch (error) {
			console.error('Error fetching Yotpo CDN reviews:', error);
			return {reviews: [], products: []};
		}
	}

	initSlider() {
		this.options = !!this.slider.dataset.options
			? sliderOptions[this.slider.dataset.options]
			: {};
		this.options = {...this.defaultOptions, ...this.options};

		this.splide = new Splide(this.slider, this.options);

		setTimeout(() => {
			this.splide.mount();
		}, 10);
	}

	async getProductInfo(yotpoProductId) {
		const gid = `gid://shopify/Product/${yotpoProductId}`;

		const query = `
    {
      product(id: "${gid}") {
        id
        title
        handle
        tags
      }
    }
  `;

		try {
			const response = await fetch('/api/2025-10/graphql.json', {
				method: 'POST',
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify({query}),
			});

			const result = await response.json();
			return result.data.product || null;
		} catch (error) {
			console.error('Error fetching product info', error);
			return null;
		}
	}
}
